function doAjaxUpdateCart(productId,quantity,cartButton,Price,productItem) {
  var checkInv = $(cartButton).data("line"),
    price = parseFloat(Price.data("price")) * quantity,
    price2 = parseFloat(Price.data("price")) * checkInv;

  let isCompoundItem = $(productItem).is("[data-product-ids]");
  let ajaxurl = isCompoundItem ? "/cart/update.js" : "cart/change.js";
  let data = "quantity=" + quantity + "&id=" + productId;

  if (isCompoundItem) {
    var itemsProcessed = $(productItem).attr("data-product-ids");
    var itemsArray = itemsProcessed.split(",").filter((item) => item);
    var qty = 0;
    data = { updates: {} };

    for (i = 0; i < itemsArray.length; i++) {
      data.updates[itemsArray[i]] = quantity;
    }
  }

  $.ajax({
    type: "post",
    url: ajaxurl,
    data: data,
    dataType: "json",
    beforeSend: function () {
      showLoading();
    },
    success: function (cart) {
      if (quantity == 0) {
        productItem.remove();
      }

      if (cart.item_count < 1) {
        $(".wrapper-cart-template").hide();
        $(".no-item-cart").show();
      }

      Price.html(Shopify.formatMoney(price, window.money_format));
      $(".total .price").html(
        Shopify.formatMoney(cart.total_price, window.money_format)
      );

      updateDropdownCart();
      
      if (
        cart.cart_level_discount_applications.length > 0 &&
        $("[data-cart-discount-wrapper]").length
      ) {
        var cartDiscounts = cart.cart_level_discount_applications;
        var title = cartDiscounts[0].title;
        var total_discount = cartDiscounts[0].total_allocated_amount;
        $("[data-cart-discount-wrapper]").show();
        $("[data-cart-discount-title]").text(title);
        $("[data-cart-discount-amount]").html(
          Shopify.formatMoney(total_discount, window.money_format)
        );
      } else {
        $("[data-cart-discount-wrapper]").hide();
      }
    },
    error: function (xhr) {
      hideLoading();
    },
  });
}


function initRemoveFromCartForm()
{
  
  $(".cart-form .remove ").on("click", function (event) {
    event.preventDefault();

    var onRemoval = function (cart) {
      //doUpdateDropdownCart(cart);
      
      $(productItem).remove();

      $(".total .price").html(
        Shopify.formatMoney(cart.total_price, window.money_format)
      );

      if (
        $("#gift-wrapping").length &&
        productId == $("#gift-wrapping").data("gift-id")
      ) {
        $("#is-a-gift").show();
      }

      if ($(".cart_items ul li").children().length > 0) {
        $(".no-item-cart").hide();
        $(".wrapper-cart-template").show();
      } else {
        $(".wrapper-cart-template").hide();
        $(".no-item-cart").show();
      }
    };

    var productItem = $(this).parents(".cart-product-item"),
      productId = $(productItem).data("item-id");

    if ($(this).is("[data-product-ids]") == true) {
      // remove compound product

      var itemsProcessed = $(this).attr("data-product-ids");
      var itemsArray = itemsProcessed.split(",").filter((item) => item);
      var qty = 0;
      var data = { updates: {} };

      for (i = 0; i < itemsArray.length; i++) {
        data.updates[itemsArray[i]] = qty;
      }

      jQuery.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: data,
        dataType: "json",
        success: function () {
          Shopify.getCart(onRemoval);
        },
      });
    } else {
      // remove single product
      Shopify.removeItem(productId, onRemoval);
    }
  });
}

function initPlusMinusQuantity()
{
  var buttonSlt = "[data-minus-quantity], [data-plus-quantity]";
  // just a proxy
  $(document).on("click", buttonSlt, function (e) {
      e.preventDefault();
      e.stopPropagation();
      var self = $(this),
        input =
          self.siblings('input[name="quantity"]').length > 0
            ? self.siblings('input[name="quantity"]')
            : self.siblings('input[name="group_quantity"]');
  
      var id = self.closest("[data-item-id]").data("item-id");
      if (input.length < 1) {
        input = self.siblings('input[name="updates[]"]');
      }
      var val = parseInt(input.val());
      if (self.hasClass("plus")) {
        val++;
        
      }
      if (self.hasClass("minus") && val > 0) {
        val--;
      }

      input.val(val);
      input.trigger("change");
  });
  
}


$(document).ready(()=>{
  
  var buttonSlt = "[data-minus-quantity], [data-plus-quantity]",
      buttonElm = $(buttonSlt),
      inputQ = $(".update-cart--template");


  setTimeout(()=> {initRemoveFromCartForm();}, 0);
  setTimeout(()=> {initPlusMinusQuantity();}, 0);
  
  
  inputQ.on("change", function () {
    var self = $(this);
    var productItem = self.parents(".cart-product-item"),
      line = self.data("line"),
      quantity = parseInt(self.val()),
      productId = $(productItem).data("item-id"),
      Price = productItem.find(".price");
   
      self.parent().css("border-color", "#cdcdcd");
    
    doAjaxUpdateCart(productId,quantity,self,Price,productItem);
    
  });

});